import React, { useContext } from "react"
import MetaTags from "react-meta-tags"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//Import DPComponents
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import { TransactionTypeMasterTab1 } from "./TransactionTypeMasterTab1"

import { Context } from '../../../app-contexts/CommonContexts';

const TransactionTypeMaster = (props) => {
  //import from contexts
  const {
    isHeadOffice
  } = useContext(Context);
  //import from contexts

  return (
    <div>
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Transaction Type Master</title>
          </MetaTags>
          <Container fluid={true}>
            <Breadcrumbs title="Master Files" breadcrumbItem="Transaction Type Master" />
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <DPTopToolBar
                      //Help Button
                      helpEnable={true}
                      helpClick={() => {
                        alert("Help")
                      }}
                      //Favorite Button
                      favoriteEnable={true}
                      favoriteClick={() => {
                        alert("Favorite")
                      }}
                      //New Button
                      newEnable={true}
                      newClick={() => {
                        alert("New")
                      }}
                      //Save Button
                      saveEnable={true}
                      saveClick={() => {
                        alert("Save")
                      }}
                      //ProcessButton
                      processEnable={true}
                      processClick={() => {
                        alert("Process")
                      }}
                      //Edit Button
                      editEnable={true && isHeadOffice}
                      editClick={() => {
                        alert("Edit")
                      }}
                      //Print Button
                      printEnable={true}
                      printClick={() => {
                        alert("Print")
                      }}
                      //Delete Button
                      deleteEnable={true}
                      deleteClick={() => {
                        alert("Delete")
                      }}
                      //Exit Button
                      exitEnable={false}
                      exitClick={() => {
                        alert("Exit")
                      }}
                    />
                    <Row>
                      <TransactionTypeMasterTab1></TransactionTypeMasterTab1>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    </div>
  )
}

export default TransactionTypeMaster;